export default "__VITE_ASSET__0019fc50__"